import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import Reports from "../../components/reports/Reports";
import Footer from "../../components/common/Footer";
import { Box } from "@mui/material";
export default function ReportsPage() {
  return (
    <Box
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <TitleBar />
        <NavMenu />
        <Reports />
      </Box>
      <Footer />
    </Box>
  );
}
